import { z } from "zod";
import { tokenAliasOrValue } from "./base";

export const ProductCopyValue = z.string();
export const ProductCopyTokenData = tokenAliasOrValue(ProductCopyValue);

export type ProductCopyValue = z.infer<typeof ProductCopyValue>;
export type ProductCopyTokenData = z.infer<typeof ProductCopyTokenData>;
